/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button } from '@coursera/cds-core';
import type { ButtonProps } from '@coursera/cds-core';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/account-settings';

const TrackedButton = withSingleTracked({ type: 'BUTTON' })<ButtonProps>(Button);

const styles = {
  // Styles are unsetting this.
  button: css`
    box-shadow: inset 0 0 0 1px var(--cds-color-interactive-primary);
  `,
};

export default class EnableTwoFactoryAuthentication extends React.Component {
  enableTwoFactorAuthentication = () => {
    SettingsActionCreators.enableTwoFactorAuthentication();
  };

  render() {
    return (
      <div className="bt3-row">
        <div className="bt3-col-md-9">
          <p>
            <FormattedMessage
              message={_t(
                `Two-Factor Authentication adds an additional layer of
                security to your Coursera account. Each time you log in to Coursera,
                you will be asked to enter a unique code that is only available on
                your mobile phone. This extra protection ensures that you are the only
                one who will have access to your Coursera account and courses.`
              )}
            />
          </p>
          <TrackedButton
            variant="primaryInvert"
            css={styles.button}
            onClick={this.enableTwoFactorAuthentication}
            trackingName="enable_two_factor_auth"
          >
            {_t('Enable Two-Factor Authentication?')}
          </TrackedButton>
        </div>
      </div>
    );
  }
}
